import script from "./PushNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./PushNotifications.vue?vue&type=script&setup=true&lang=js"

import "./PushNotifications.vue?vue&type=style&index=0&id=520fa058&lang=scss"

const __exports__ = script;

export default __exports__